import { MenuOptionType } from "@dexteel/mesf-core";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import { Charge } from "@/pages/sy/models/Charge";

type Props = {
  setCharge: (charge: Charge) => void;
  setShowModal: (modal: "new" | "edit" | "delete" | "") => void;
  handleNewCharge: () => void;
};
export const useChargeOptionsFunctions = ({
  setCharge,
  setShowModal,
  handleNewCharge,
}: Props) => {
  const getMenuOptions = (data: Charge) => {
    let options: MenuOptionType[] = [];
    options = options.concat([
      {
        name: "New Charge",
        key: "new_charge",
        onClick: () => {
          handleNewCharge();
        },
        icon: <PlaylistAddIcon />,
      },
    ]);
    if (data) {
      options = options.concat([
        {
          name: "Delete Charge",
          key: "delete_charge",
          onClick: () => {
            setCharge(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
